import React, { useEffect, useMemo, useRef, useState } from 'react';
import Icon from '../Icon/Icon';
import styles from './BackgroundMusicThumbnail.module.scss';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { throttle } from 'engage/utils/general';

const initialMusicVolume = 50;
const initialVideoVolume = 100;

const BackgroundMusicThumbnail = ({ clip, clipIndex, onBackgroundMusicChange }) => {
  const [isVideoVolumeHover, setIsVideoVolumeHover] = useState(false);
  const [isMusicVolumeHover, setIsMusicVolumeHover] = useState(false);

  const containerRef = useRef();

  const { t } = useTranslation();

  const handleMuteUnmuteVideo = event => {
    event.stopPropagation();
    event.preventDefault();

    const musicVolume = clip.music?.volume ?? initialMusicVolume / 100;
    const videoVolume = clip.videoVolume === 0 ? initialVideoVolume / 100 : 0;
    onBackgroundMusicChange({ sceneIndex: clipIndex, newMusic: clip.music, musicVolume, videoVolume });
  };

  const handleMuteUnmuteMusic = event => {
    event.stopPropagation();
    event.preventDefault();

    const musicVolume = clip.music?.volume === 0 ? initialMusicVolume / 100 : 0;
    const videoVolume = clip.videoVolume ?? initialVideoVolume / 100;
    onBackgroundMusicChange({ sceneIndex: clipIndex, newMusic: clip.music, musicVolume, videoVolume });
  };

  const [iconsSize, setIconsSize] = useState('medium');

  useEffect(() => {
    const defineIconsSize = () => {
      let size = 'medium';
      if (containerRef.current) {
        if (containerRef.current.parentNode.offsetWidth < 90) {
          size = 'small';
        }
        if (containerRef.current.parentNode.offsetWidth > 125) {
          size = 'large';
        }
      }
      setIconsSize(size);
    };

    let resizeObserver = null;
    if (containerRef?.current?.parentNode) {
      resizeObserver = new ResizeObserver(throttle(entries => {
          entries.forEach(() => {
            defineIconsSize();
          });
      }, 150));
      resizeObserver.observe(containerRef?.current?.parentNode);
    }

    return () => resizeObserver && resizeObserver.disconnect(containerRef?.current?.parentNode);
  }, [containerRef?.current?.parentNode]);

  return (
    <div ref={containerRef} className={cx(styles.container, [styles[iconsSize]])}>
      <div className={styles.hoverContainer}>
        <div
          onMouseOver={() => setIsVideoVolumeHover(true)}
          onMouseLeave={() => setIsVideoVolumeHover(false)}
          className={styles.iconContainer}
          onClick={handleMuteUnmuteVideo}
        >
          <Icon className={styles.icon} src={clip.videoVolume === 0 ? 'noVideoVolumeWhite' : 'videoVolumeWhite'} />
        </div>
      </div>
      <div className={cx(styles.hoverContainer, { [styles.disabled]: !clip.music })}>
        <div
          onMouseOver={() => setIsMusicVolumeHover(true)}
          onMouseLeave={() => setIsMusicVolumeHover(false)}
          className={styles.iconContainer}
          onClick={handleMuteUnmuteMusic}
        >
          <Icon className={styles.icon} src={!clip.music || clip.music?.volume === 0 ? 'noMusic' : 'musicVolumeWhite'} />
        </div>
      </div>
    </div>
  );
};

export default BackgroundMusicThumbnail;
